<app-dialog-heading [heading]="'Create Refill'"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="refillFormGroup">

    <mat-form-field>
      <mat-label>Refill Reference Name</mat-label>
      <input matInput type="text" [formControl]="nameFormControl" required>
    </mat-form-field>

    <br>

    <mat-form-field>
      <mat-label>Refill Measure</mat-label>
      <mat-select [formControl]="measureFormControl" required>
        <mat-option *ngFor="let measure of refillMeasures" [value]="measure.name">
          {{measure.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <br>

    <mat-form-field>
      <mat-label>Refill Value</mat-label>
      <input matInput type="number" [formControl]="valueFormControl" required>
    </mat-form-field>

  </form>
  <p style="color: red">{{errorMessage}}</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button (click)="onSaveClick()" color="primary">Save</button>
  <button class="dialog-button" mat-raised-button (click)="onCancelClick()" color="warn" >Cancel</button>
</mat-dialog-actions>
